"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importStar(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_loops_1 = require("react-loops");
const reactstrap_1 = require("reactstrap");
const Item_1 = require("./Item");
const react_if_1 = require("react-if");
const ui_1 = require("../../ui");
const __1 = require("../..");
const react_use_1 = require("react-use");
const hooks_1 = require("../../../hooks");
const useOsmosysPaginatedItems_1 = require("./hooks/useOsmosysPaginatedItems");
const Toolbar_1 = require("./Toolbar");
function OsmosysListLayout(props) {
    // Props
    const { emptyComp, query, children, itemProps, showReloadButton, pageSize = 5, pathToItems, pathToCount, itemName = 'item', itemsName = 'items', toolbarLeft, toolbarRight, onNewResourceButtonClick, resource, argsAsInput = false, } = props;
    const { query: graphqlQueryDocument } = query, queryProps = tslib_1.__rest(query, ["query"]);
    // Hooks
    const [activePage, pageActions] = react_use_1.useNumber(0);
    // Props computed
    const defaultPageSize = pageSize || 5;
    const args = Object.assign(Object.assign({}, queryProps.variables), { skip: activePage * defaultPageSize, take: defaultPageSize });
    const queryOptions = Object.assign(Object.assign({}, queryProps), { fetchPolicy: 'cache-and-network', 
        // fetchPolicy: 'network-only',
        variables: argsAsInput ? { args } : args });
    const queryResult = react_hooks_1.useQuery(graphqlQueryDocument, queryOptions);
    // Local storage
    const localStorageKey = hooks_1.useOsmosysObjectHash(queryOptions, {});
    const [localMeta, setLocalMeta] = react_use_1.useLocalStorage(`osmosys:list:${itemName}:${localStorageKey}`, {
        serverSideCount: null,
    });
    // Query computed
    const { data } = queryResult;
    const hasLoaded = !!data;
    const placeholderCount = Math.ceil(Math.min(typeof localMeta.serverSideCount === 'number'
        ? localMeta.serverSideCount
        : defaultPageSize, defaultPageSize));
    const { loadedItems, pagination } = useOsmosysPaginatedItems_1.useOsmosysPaginatedItems({
        activePage,
        data,
        onPageChange: newPage => {
            pageActions.set(newPage);
        },
        pageSize: defaultPageSize,
        pathToCount,
        pathToItems,
        placeholderCount,
        showPlaceholders: !hasLoaded,
    });
    // Update local meta
    react_1.useEffect(() => {
        if (hasLoaded) {
            setLocalMeta({
                serverSideCount: loadedItems.length,
            });
        }
    }, [loadedItems.length, hasLoaded]);
    const reloadButton = showReloadButton && (react_1.default.createElement("div", null,
        react_1.default.createElement(reactstrap_1.Button, { color: "dark", size: "sm", outline: true, disabled: queryResult.loading, onClick: () => {
                queryResult.refetch();
            } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faSync, spin: __1.queryIsLoading(queryResult) }))));
    const reloadButtonCol = showReloadButton && (react_1.default.createElement(react_1.default.Fragment, null, showReloadButton && (react_1.default.createElement(reactstrap_1.Col, { className: classnames_1.default('flex-grow-0 flex-shrink-1', {
            'ml-auto': true,
        }) }, reloadButton))));
    return (react_1.default.createElement(reactstrap_1.Container, { className: "flex-full-col", fluid: true },
        (toolbarLeft || reloadButtonCol) && (react_1.default.createElement(Toolbar_1.OsmosysListLayoutToolbar, { showReloadButton: showReloadButton, queryResult: queryResult, toolbarLeft: toolbarLeft, toolbarRight: toolbarRight, onNewResourceButtonClick: onNewResourceButtonClick, onReload: () => {
                queryResult.refetch();
            } })),
        react_1.default.createElement(react_if_1.If, { condition: !!queryResult.error },
            react_1.default.createElement(react_if_1.Then, null,
                react_1.default.createElement(ui_1.OsmosysUndesiredState, { message: `Failed to load ${itemsName}`, level: "danger" }),
                react_1.default.createElement(ui_1.OsmosysErrorAlert, { resource: resource, pluralResource: true, action: "read", apolloError: queryResult.error, floatBottom: false, retry: queryResult.refetch })),
            react_1.default.createElement(react_if_1.Else, null,
                react_1.default.createElement(reactstrap_1.Row, { className: "flex-full-col-centered" },
                    react_1.default.createElement(reactstrap_1.Col, { className: "flex-col-centered" },
                        react_1.default.createElement(react_loops_1.For, { of: loadedItems, ifEmpty: () => (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(ui_1.OsmosysUndesiredState, { message: `No ${itemsName}`, level: "notFound" }, emptyComp))) }, (item, { index }) => {
                            const id = item && item.id && typeof item.id === 'number'
                                ? item.id
                                : index;
                            if (item.isPlaceholder) {
                                return react_1.default.createElement(Item_1.OsmosysListItem, { key: id, isPlaceholder: true });
                            }
                            if (!itemProps) {
                                if (children) {
                                    return react_1.default.createElement(react_1.default.Fragment, null, children(item, queryResult));
                                }
                                else {
                                    return react_1.default.createElement(Item_1.OsmosysListItem, { key: id, isPlaceholder: true });
                                }
                            }
                            const itemComp = (react_1.default.createElement(Item_1.OsmosysListItem, Object.assign({ key: id }, itemProps(item, queryResult))));
                            return itemComp;
                        }))),
                react_1.default.createElement(OsmosysListLayoutPaginationWrapper, null, pagination)))));
}
exports.OsmosysListLayout = OsmosysListLayout;
const OsmosysListLayoutPaginationWrapper = ({ children }) => {
    return (react_1.default.createElement(reactstrap_1.Row, null,
        react_1.default.createElement(reactstrap_1.Col, { className: "flex-col-centered" },
            react_1.default.createElement("div", null, children))));
};
//# sourceMappingURL=index.js.map